import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterPipe, OrderByPipe } from '@wm/components-base';
import { BaseComponent } from '@wms/components';
import { WmsToggleComponent } from '../wms-toggle/wms-toggle.component';
import { TabsModule } from "ngx-bootstrap/tabs";

@Component({
  selector: 'wms-template-config',
  standalone: true,
  templateUrl: './template-config.component.html',
  styleUrls: ['./template-config.component.less'],
  imports: [
    CommonModule,
    WmsToggleComponent,
    FormsModule,
    OrderByPipe,
    FilterPipe,
    TabsModule
  ],
  host: {class: 'wms-wizard-body-content'}
})
export class TemplateConfigComponent extends BaseComponent implements OnInit {
  @Input() activeLiveWidget?: any;
  @Input() currentStep!: any;
  @Input() activeInnerStep!: any;
  @Input() widgetType!: any;
  @Input() widgetConfig!: any;
  @Input() widgetDetails!: any;
  @Input() liveWidgetLayouts!: any;
  @Input() gridOptions!: any;
  @Input() navigationList!: any;
  @Input() selectedLiveWidgetLayout!: any;
  @Input() liveWidgetNavigation!: any;
  @Input() variableFilter!: any;
  @Input() steps!: any;
  @Output() selectWidgetLayout = new EventEmitter<any>();
  @Output() setLiveWidgetNavigation = new EventEmitter<any>();
  @Output() updateGridTemplates = new EventEmitter<any>();
  @Output() setCaptionAlign = new EventEmitter<any>();
  @Output() setCaptionPosition = new EventEmitter<any>();
  @Output() updateWidgetFormType = new EventEmitter<any>();
   fileOptionsList:any = [];


  captionPositions = ['left', 'right', 'top', 'floating'];
  captionAlignments = ['left', 'center', 'right'];
  navType: any;
  align: any;
  position: any;
  isNativeMobileApplicationType: boolean;
  isMobileApplicationType: boolean;
  isPrismWeb: boolean;

  constructor() {
    super();
    this.isNativeMobileApplicationType = this.projectService.isNativeMobileApplicationType();
    this.isMobileApplicationType = this.projectService.isMobileApplicationType();
    this.isPrismWeb = this.projectService.isPrismWeb();
  }

  ngOnInit(): void {
    this.fileOptionsList.push({name: this.locale.LABEL_READONLY, active: !this.gridOptions.isEditable, value: false}, {name: this.locale.LABEL_EDITABLE, active: this.gridOptions.isEditable, value: true});
  }

  updateWidgetMode(widgetMode: any){
    this.widgetConfig.widgetMode = widgetMode ? this.locale.LABEL_EDITABLE : this.locale.LABEL_READONLY;
  }

  onEditToggle(val: any) {
    this.updateGridTemplates.emit(val);
  }

  onWidgetSelect(template: any) {
    this.selectWidgetLayout.emit(template);
  }

  onNavigationSelect(navType: any) {
    this.setLiveWidgetNavigation.emit(navType);
  }

}
